export default {
  "content": "<path fill=\"#F2F2F2\" d=\"M0 10C0 4.477 4.477 0 10 0s10 4.477 10 10-4.477 10-10 10S0 15.523 0 10z\"/><path fill=\"#333\" d=\"M11.775 6.775L9.5 4.5v1.535A3.998 3.998 0 006 10c0 2.04 1.525 3.72 3.5 3.965v-1.01A2.999 2.999 0 017 10a2.999 2.999 0 012.5-2.955V9l2.275-2.225zm2.19 2.725a3.953 3.953 0 00-.81-1.945l-.71.71c.27.375.44.8.51 1.235h1.01zM10.5 12.95v1.01a3.962 3.962 0 001.95-.805l-.72-.72c-.375.27-.795.445-1.23.515zm1.945-1.21l.71.705c.45-.58.725-1.25.81-1.945h-1.01c-.07.435-.24.86-.51 1.24z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "20",
    "height": "20",
    "fill": "none",
    "viewBox": "0 0 20 20"
  }
};